import { render, staticRenderFns } from "./pie-basic.vue?vue&type=template&id=74b71ee6"
import script from "./pie-basic.vue?vue&type=script&lang=js"
export * from "./pie-basic.vue?vue&type=script&lang=js"
import style0 from "./pie-basic.vue?vue&type=style&index=0&id=74b71ee6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports